<template>
    <div>
        <div class="d-flex justify-space-between align-center">
            <div>
            <!-- tabs -->
            <v-tabs v-model="tab" show-arrows height="35">
               <!-- / v-if="!firstLevel"  -->
                <v-tab
                    class="text-capitalize "
                    :to="{ 
                        name: 'warehouses-statistics'
                    }"
                >
                    {{$t('SamplesTabs.warehouses-statistics')}}
                </v-tab>

                <v-tab
                    class="text-capitalize "
                    :to="{ 
                        name: 'samples-statement'
                    }"
                >
                {{$t('SamplesTabs.materials-statement')}}    
                </v-tab>

                <v-tab
                    v-if="!firstLevel"
                    class="text-capitalize "
                    :to="{ 
                        name: 'minimal-interface'
                    }"
                >
                    {{$t('SamplesTabs.material-stock-limit')}}
                </v-tab>

                <v-tab 
                    v-if="materialStockByCity"
                    class="text-capitalize "
                    :to="{
                        name: 'materials-stock-by-city-statistics'
                    }"
                >
                    {{ $t('SamplesTabs.materials-stock-by-city-statistics') }}
                </v-tab>

                <v-tabs-slider color="primary"></v-tabs-slider>
            </v-tabs>
            <v-divider v-if="!$route.query.preview" class="mb-2"/>
            </div>
            <!-- <div> -->
            <v-spacer />
            <v-btn
                v-if="isSuperAdmin || permissionsUser.MaterialTransactions !== roleName.nothing"
                small
                :to="{ 
                    name: 'supervisor-remaining-samples', 
                    query: {
                        from: 'statistics'
                    } 
                }"
                color="light-blue white--text"
            >
                {{$t('JournalItems.remaining-samples')}}
            </v-btn>
            <!-- </div> -->
        </div>

         <!-- child page -->
        <loader v-if="loading"/>
        <router-view v-else/>
    </div>
</template>
<script>
import { firstLevel, materialStockByCity } from '@/configs/global.config'
import { mapState } from 'vuex'
import { roleName } from '@/helpers/enums'
export default {
    data() {
        return {
            tab: 0,
            loading: false,
            firstLevel,
            roleName,
            materialStockByCity
        }
    },

    computed: {
        ...mapState({
            permissionsUser: state => state.auth.youPermissions,
            isSuperAdmin: state => state.auth.isSuperAdmin,
            staff: state => state.entities.staff,
            customers: state => state.entities.customers,
        })
    },

    created() {
        if (!this.staff?.length) this.$store.dispatch('accounts/fetchAllBrief', { type: 0, regionIds: [], nonDeleted: false })
        if (this.customers?.length) this.$store.dispatch('accounts/fetchAllBrief', { type: 1, regionIds: [], nonDeleted: false })
    }
}
</script>
